import { ConnectButton } from '@rainbow-me/rainbowkit';

export const Connect = () => {
  return <ConnectButton />;
};